import { skipToken, useQuery } from '@tanstack/react-query';

import { IQuestionary } from '@/interfaces/IQuestionary';

import api from '../services/api';

export const getMissionReportQuestionary = ({
  unitId
}: {
  unitId: string;
}): Promise<{ data: { data: { questionary: IQuestionary } } }> =>
  api.get(`/api/frontend/mission_reports/questionary`, { params: { unit_id: unitId } });

export const useMissionReportQuestionary = ({ unitId }: { unitId: string | undefined }) =>
  useQuery({
    queryKey: ['mission_report_questionary', unitId],
    queryFn: unitId ? () => getMissionReportQuestionary({ unitId }) : skipToken,
    select: data => data.data.data.questionary
  });
